<!-- Wrapper-->
<div class="app-wrapper">
  <!-- Main page wrapper -->
  <div class="router-wrapper">
    <!-- Main view/routes wrapper-->
    <router-outlet></router-outlet>
  </div>

  <!-- Busy Icon-->
  <div [cgBusy]="this.busySubscription" [cgBusyConfig]="{templateRef: busyTemplate, minDuration: 0}"></div>
  <ng-template #busyTemplate let-options="options">
    <div class='loadingSpinnerContainer'>
      <div>
        <img id='loadingOCCONSpinner' [src]="this.loadingIcon"/>
        <h2 id='loadingText'><b>{{this.busyIconService.currentMessage}}</b></h2>
      </div>
    </div>
  </ng-template>
  <!-- End page wrapper-->
</div>
<!-- End wrapper-->
